import Routines from "./routines";

export default [
  // Each object is a day
  {
    complete: false,
    length: "30 min",
    locked: true,
    routines: Routines.week9day1,
    title: "Advanced Core Strength I",
  },

  {
    complete: false,
    length: "30 min",
    locked: true,
    routines: Routines.week9day1,
    title: "Advanced Core Strength I",
  },

  {
    complete: false,
    length: "30 min",
    locked: true,
    routines: Routines.week9day1,
    title: "Advanced Core Strength I",
  },

  {
    complete: false,
    length: "30 min",
    locked: true,
    routines: Routines.week9day1,
    title: "Advanced Core Strength I",
  },

  {
    complete: false,
    length: "30 min",
    locked: true,
    routines: Routines.week9day1,
    title: "Advanced Core Strength I",
  },

  {
    complete: false,
    length: "30 min",
    locked: true,
    routines: Routines.week9day1,
    title: "Advanced Core Strength I",
  },

  {
    complete: false,
    length: "30 min",
    locked: true,
    routines: Routines.week9day1,
    title: "Advanced Core Strength I",
  },
];
